































import { Component, Vue, Prop, VModel } from "vue-property-decorator";
import Loading from "@/shared/components/loading.vue";

@Component({
  components: {
    Loading,
  },
})
export default class Modal extends Vue {
  @VModel({ type: Boolean, default: false }) input!: boolean;

  @Prop() title!: string;
  @Prop() loading!: boolean;
  @Prop() width!: string;
  resolve?: (value: boolean | PromiseLike<boolean>) => void;

  dialog = false;

  public open() {
    this.dialog = true;
    return new Promise<boolean>((resolve) => {
      this.resolve = resolve;
    });
  }

  public close(res: boolean) {
    this.dialog = false;
    if (this.resolve) {
      return this.resolve(res);
    }
  }

  mounted() {
    if (this.input) {
      this.open();
    } else {
      this.close(false);
    }
  }
}
